// react
import React from 'react';
import { useTranslation } from 'react-i18next';

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import NavPills from "beaktShared/components/NavPills/NavPills.js";
import Card from "beaktShared/components/Card/Card.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import DadosEstabelecimento from "beaktMatriz/views/Credenciamento/Steps/DadosEstabelecimento.js";
import PagamentoEstabelecimento from "beaktMatriz/views/Credenciamento/Steps/PagamentoEstabelecimento.js";
import RoyaltiesEstabelecimento from "beaktMatriz/views/Credenciamento/Steps/RoyaltiesEstabelecimento.js";
import ContatoEstabelecimento from "beaktMatriz/views/Credenciamento/Steps/ContatoEstabelecimento.js";
import VendaEstabelecimento from "beaktMatriz/views/Credenciamento/Steps/VendaEstabelecimento.js";

// icons
import PermIdentity from "@material-ui/icons/PermIdentity";

export default function Credenciamento({ history ,item, handleView }) {
  const { t } = useTranslation();

  const [itemCred, setitemCred] = React.useState(item);
  
  const handleVoltar = () =>{
    handleView(true, itemCred);
  }

  const updateitemCred = (itemUpdate) =>{
    setitemCred(itemUpdate);
  }

return (
    <div className="maxContent">   
     <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary" icon>
                <CardIcon color="primary">
                    <PermIdentity />
                </CardIcon>
                <h4 style={{color:'black'}}>
                  {t('sidebar.accreditation')} 
                  <br/>
                  <small> {t('accreditation.the_registration_is_not_incomplete')} <b> {t('label.required')} </b> {t('accreditation.inform')}
                  </small>
                </h4>
            </CardHeader>
            <CardBody>
              <div>
              <NavPills
                color="primary"
                tabs={[
                  {
                    tabButton: t('label.establishment_details'),
                    tabContent: (
                      <DadosEstabelecimento item={itemCred} CallHandleVoltar={handleVoltar} CallUpdateItem={updateitemCred} history={history} />
                    )
                  },
                  {
                    tabButton: t('sidebar.royalties'),
                    tabContent: (
                      <RoyaltiesEstabelecimento item={itemCred} CallHandleVoltar={handleVoltar} CallUpdateItem={updateitemCred} />
                    )
                  },
                  {
                    tabButton: t('label.form_of_payment'),
                    tabContent: (
                      <PagamentoEstabelecimento item={itemCred} CallHandleVoltar={handleVoltar} CallUpdateItem={updateitemCred}/>
                    )
                  },
                  {
                    tabButton: t('accreditation.additional_contacts'),
                    tabContent: (
                      <ContatoEstabelecimento item={itemCred} CallHandleVoltar={handleVoltar} CallUpdateItem={updateitemCred} />
                    )
                  },
                  {
                    tabButton: t('label.sale_settings'),
                    tabContent: (
                      <VendaEstabelecimento item={itemCred} CallHandleVoltar={handleVoltar} CallUpdateItem={updateitemCred} />
                    )
                  }
                ]}
              />
              </div>

            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
);
}